export function getEnvironmentConfig(x) {
  const host = window.location.host;
  let env = !host.includes("linkqpay.com") && !host.includes("localhost") ? "PROD" : "DEV";
  const basename = "REACT_APP_"
  return process.env[basename + env + "_" + x];
}

export function getApiBaseUrl() {
  let apiBaseUrl = process.env.REACT_APP_OVERRIDE_API_BASE_URL;
  if (apiBaseUrl) return apiBaseUrl;  
  const host = window.location.host;
  if(host.includes("localhost")){
    return process.env.REACT_APP_OVERRIDE_LOCAL_API_BASE_URL
  }
  if(host){
    const hostArr = host.split(".");
   const newUrl= hostArr.splice(1, hostArr.length - 1);
   apiBaseUrl = newUrl.join(".");
   return `https://payment-api-service.${apiBaseUrl}/payment`;
  } 
  return getEnvironmentConfig("BASE_URL");
}
